export const DepencyCreateTooltipSelectors = {
  card: 'dependency-create-tooltip-card',
  fromName: 'dependency-create-tooltip-from-name',
  toName: 'dependency-create-tooltip-to-name',
  validityChip: 'dependency-create-tooltip-validity-chip',
};
